<template>
    <section id="login-form" class="container">
        <div class="row">
            <div class="col-md-10">
                <div class="flex-wrap mr-5 mb-2 pr-3 mt-1">
                    Log in or create an account to:<br/>
                    <ul>
                        <li>Apply for a film or grid (city all) permit</li>
                        <li>Manage your film permits</li>
                        <li>View your application history</li>
                    </ul>
                    <div class="mt-3">
                        If you’re scouting or still determining permit details, like the schedule, please <b>do not submit an online application.</b> 
                    </div>
                    <div class="mt-3">
                        Instead, please email <b>film.office@mississauga.ca</b> with the details of your inquiry to avoid possible permit cancellation fees.
                    </div>
                </div>

                <!--Testing alert msg display-->   
                <!--          
                <div class="col-lg-10 offset-lg-1 d-block no-gutters pl-0">
                    <div class="alertMsg-success"> 
                        <p>Testing alert message.</p>
                    </div>
                </div>
                -->

                <div
                    class="alert alert-warning"
                    v-if="$route.query.expired !== undefined"
                >Your session has expired. Please sign in again. <!--Your work has been saved and will be recovered after signing in.--></div>
                <form class="my-3">
                    <div class="form-row">
                        <TextInput
                            inputId="username"
                            v-model.trim="formData.username"
                            labelText="Email address"
                            :wrapperClasses="['col-md-6']"
                            :isRequired="true"
                            :validateEmail="false"
                            :validation="formData.username ? [{type:'email',msg:'Please provide a valid email'}] : []"
                        />
                    </div>
                    <div class="form-row"><!--class="frow no-gutters flex-lg-nowrap"-->
                        <TextInput
                            initialType="password"
                            :inputStyleFlex="false"
                            inputId="password"
                            v-model="formData.password"
                            labelText="Password"
                            :password="true"
                            autocomplete="password"
                            :wrapperClasses="['col-md-6']"
                            :isRequired="true"
                        />

                        
                            <p class="col-auto forgotpassword">
                            <RouterLink to="/forgot-password" class="mb-0">
                                Forgot password
                            </RouterLink>
                            </p>
                            
                    </div>

                    <!-- <div class="form-row">
                        <div class="my-3 col-xs-12 col-md-6" v-if="failedAttempts > 2">
                            <vue-recaptcha
                                sitekey="6LePGyYTAAAAAHF6DUmTXY-DhX4d931Njqs1_zEY"
                                @verify="recaptchaVerify"
                                @expire="recaptchaIsValid = false; recaptchaToken = '';"
                            ></vue-recaptcha>
                        </div>
                    </div>-->
                    <!-- <div class="form-row">
                        <div class="col-xs-12 col-md-6">
                            <div
                                class="my-3 alert alert-danger"
                                v-if="submitted && !recaptchaIsValid && failedAttempts > 2"
                            >Please confirm the recaptcha box.</div>
                        </div>
                    </div>-->
                    <div class="form-row">
                        <div class="col-xs-12 col-md-8">
                            <div
                                :class="['my-3','alert','alert-'+errorMsgType]"
                                v-if="errorMsg == 'verifyEmail'"
                            >
                                <p>Your account has not been verified yet.</p>
                                <p>Please check back in your inbox and your junk folder for the verification email and click the link to login.</p>
                                <p class="mb-0">
                                    <a
                                        class="resend-email"
                                        href="#"
                                        @click.prevent="resendEmail"
                                    >Resend email to {{unverifiedEmail}}</a>
                                </p>
                            </div>
                            <div
                                :class="['my-3','alert','alert-'+errorMsgType]"
                                v-else-if="errorMsg == 'verifyEmailSuccess'"
                            >We've resent your verification email. Please check your inbox and junk folder.</div>
                            <div
                                :class="['my-3','alert','alert-'+errorMsgType]"
                                v-else-if="errorMsg.length > 0"
                            >{{errorMsg}}</div>
                        </div>
                    </div>

                    <button
                        id="login-submit"
                        :class="['btn btn-primary', loading ? 'disabled' : null]"
                        type="submit"
                        @click.prevent="login"
                    >Sign in</button>
                    <div class="spinner-container" v-if="loading">
                        <div class="spinner"></div>
                    </div>
                </form>

                <div class="my-3">
                    <p class>
                        Don't have an account?
                        <router-link to="/create-account">Register now</router-link>
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import TextInput from "@/components/inputs/TextInput";
// import VueRecaptcha from "vue-recaptcha";
import { mapGetters} from "vuex";

export default {
    name: "login",
    components: {
        TextInput
        // VueRecaptcha
    },
    data() {
        return {
            formData: {
                username: "",
                password: ""
            },
            unverifiedEmail: "",
            submitted: false,
            incorrectPassword: false,
            failedAttempts: 0,
            verifyEmail: false,
            verifyEmailStatus: "",
            loginError: false,
            loginErrorMsg: "",
            errorMsg: "",
            errorMsgType: ""
            // recaptchaIsValid: false,
            // recaptchaToken: ""
        };
    },
    computed: {
        loading() {
            return this.$store.getters.isLoading;
        },
        wasFormDataRecovered()
        {
            //console.log('abc...: ' + this.$store.getters.formDataWasRecovered)
            return this.$store.getters.formDataWasRecovered
        }
        //...mapGetters(['formDataWasRecovered'])
    },
    methods: {
        login() {
            this.submitted = true;
            this.wasFormDataRecovered;
            // reset errors
            this.errorMsg = "";
            this.errorMsgType = "";
            // if (this.failedAttempts > 2 && !this.recaptchaValid) return;
            let { username, password } = this.formData;

            this.$store
                .dispatch("AUTH_REQUEST", {
                    username: username.toLowerCase(),
                    password: password
                })
                //.then(() => this.$router.push("/application")) 
                //BKup: .then(() => this.$router.push("/dashboard")) 
               // .then(() => this.$router.push({ name: "Dashboard" }))
               .then(() => {
                   if(this.wasFormDataRecovered)
                   {
                       this.$router.push("/application");
                   }     
                   else
                   {
                       this.$router.push("/dashboard");
                   }          
               }) 

                .catch(resp => {
                    switch (resp.error) {
                        case "invalid_email_not_confimed": {
                            this.errorMsg = "verifyEmail";
                            this.errorMsgType = "danger";
                            this.unverifiedEmail = this.formData.username;
                            break;
                        }
                        case "invalid_grant_passaccesslogincount": {
                            this.errorMsgType = "danger";
                            this.errorMsg =
                                "Provided username and password is incorrect";
                            break;
                        }
                        default: {
                            this.errorMsgType = "danger";
                            this.errorMsg = resp.error_description;
                        }
                    }
                    this.failedAttempts++;
                });
        },
        resendEmail() {
            // reset errors
            this.loginError = false;
            this.verifyEmail = false;
            this.loginErrorMsg = "";
            this.verifyEmailStatus = "";

            this.$store
                .dispatch("AUTH_RESEND_VERIFY_EMAIL", this.formData.username)
                .then(({ data }) => {
                    switch (data) {
                        case "email_is_sent": {
                            this.errorMsgType = "success";
                            this.errorMsg = "verifyEmailSuccess";
                            break;
                        }

                        case "no_record_found": {
                            this.errorMsgType = "danger";
                            this.errorMsg =
                                "That email wasn't found in our database. Go to create an account to make an account with that email.";
                            break;
                        }

                        default: {
                            this.errorMsgType = "danger";
                            this.errorMsg =
                                "An unknown error occurred while trying to resend your verification email. Check your internet connection and try refreshing the page before trying again. If this continues, please contact the film office.";
                        }
                    }
                })
                .catch(() => {
                    this.errorMsgType = "danger";
                    this.errorMsg =
                        "An unknown error occurred while trying to resend your verification email. Check your internet connection and try refreshing the page before trying again. If this continues, please contact the film office.";
                });
        }
        // recaptchaVerify(evt) {
        //     this.recaptchaToken = evt;
        //     this.recaptchaIsValid = true;
        // }
    }
};
</script>
<style scoped>
    .test {
        text-decoration: none;
        color: red !important;
      }
    .test:before {
        font-family: "Font Awesome 5 Free";
        content: "\f00d";
        display: inline-block;
        padding-right: 3px;
        vertical-align: middle;
        font-weight: 900;
      }

</style>

